import { ColGroupDef, GridOptions } from 'ag-grid-community'
import useDefaultColumns, {
  useTaskEstimatedColumnDef,
  useDeliverableEstimatedColumnDef,
} from './defaultColumns'
import defaultGridOptions from './defaultGridOptions'
import { MutableRefObject, useMemo } from 'react'

const useWatcherTabColumnDef = (
  priorityOrderMapRef: MutableRefObject<Map<string, number>>
) => {
  const defaultColDef = useDefaultColumns(priorityOrderMapRef)
  const taskEstimatedColumnDef = useTaskEstimatedColumnDef()
  const deliverableEstimatedColumnDef = useDeliverableEstimatedColumnDef()
  const columnDefs = useMemo(() => {
    const estimatedGroup = defaultColDef.find(
      colDef => colDef.externalId === 'myWbsItems.estimated'
    ) as ColGroupDef | undefined
    if (estimatedGroup && estimatedGroup.children) {
      estimatedGroup.children.push(taskEstimatedColumnDef)
      estimatedGroup.children.push(deliverableEstimatedColumnDef)
    }
    return defaultColDef
  }, [defaultColDef, taskEstimatedColumnDef, deliverableEstimatedColumnDef])
  return columnDefs
}

export const useMyWbsItemWatcherTabGridOptions = (
  priorityOrderMapRef: MutableRefObject<Map<string, number>>
): GridOptions => {
  const columnDefs = useWatcherTabColumnDef(priorityOrderMapRef)
  const gridOptions = useMemo(
    () => ({
      ...defaultGridOptions(),
      columnDefs,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
  return gridOptions
}
